var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bairun-container" },
    [
      _c(
        "div",
        { staticStyle: { "margin-bottom": "15px" } },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.onCreate } },
            [_vm._v("新建运输单号")]
          )
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          staticStyle: { width: "100%" },
          attrs: { data: _vm.tableData, stripe: "", border: "" }
        },
        [
          _c("el-table-column", {
            attrs: { prop: "transportNo", label: "运输单号" }
          }),
          _c("el-table-column", {
            attrs: { prop: "transportName", label: "运输名称" }
          }),
          _c("el-table-column", {
            attrs: { prop: "carryTotalTon", label: "本次运送总吨数" }
          }),
          _c("el-table-column", {
            attrs: { prop: "fleetNo", label: "运油车队" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      " " + _vm._s(_vm.fleetFilters(scope.row.fleetNo)) + " "
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { prop: "carNumber", label: "车牌号" }
          }),
          _c("el-table-column", {
            attrs: { prop: "driverName", label: "司机名称" }
          }),
          _c("el-table-column", {
            attrs: { prop: "CreatedAt", label: "创建时间" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(_vm._s(_vm._f("formatDate")(scope.row.CreatedAt)))
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c("el-pagination", {
        style: { float: "right", padding: "20px" },
        attrs: {
          "current-page": _vm.page,
          "page-size": _vm.pageSize,
          "page-sizes": [10, 30, 50, 100],
          total: _vm.total,
          layout: "total, sizes, prev, pager, next, jumper"
        },
        on: {
          "current-change": _vm.handleCurrentChange,
          "size-change": _vm.handleSizeChange
        }
      }),
      _c(
        "el-dialog",
        {
          attrs: { title: "新增", visible: _vm.dialogVisible },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "rulesForm",
              attrs: { model: _vm.formData, rules: _vm.formRules }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "车队选择", prop: "fleetNo" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        filterable: "",
                        clearable: "",
                        placeholder: "请选择"
                      },
                      on: { change: _vm.fleetChange, clear: _vm.fleetClear },
                      model: {
                        value: _vm.formData.fleetNo,
                        callback: function($$v) {
                          _vm.$set(_vm.formData, "fleetNo", $$v)
                        },
                        expression: "formData.fleetNo"
                      }
                    },
                    _vm._l(_vm.fleetList, function(item) {
                      return _c("el-option", {
                        key: item.ID,
                        attrs: { label: item.fleetName, value: item.fleetNo }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "车辆列表", prop: "carNumber" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        filterable: "",
                        clearable: "",
                        placeholder:
                          _vm.formData.fleetNo == "" ||
                          _vm.formData.fleetNo == undefined
                            ? "请选择车队"
                            : "请选择",
                        disabled:
                          _vm.formData.fleetNo == "" ||
                          _vm.formData.fleetNo == undefined
                            ? true
                            : false
                      },
                      on: { change: _vm.fleetcarChange },
                      model: {
                        value: _vm.formData.carNumber,
                        callback: function($$v) {
                          _vm.$set(_vm.formData, "carNumber", $$v)
                        },
                        expression: "formData.carNumber"
                      }
                    },
                    _vm._l(_vm.fleetcarList, function(item) {
                      return _c("el-option", {
                        key: item.ID,
                        attrs: { label: item.carNumber, value: item.carNumber }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "司机列表", prop: "driverName" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        filterable: "",
                        clearable: "",
                        placeholder:
                          _vm.formData.fleetNo == "" ||
                          _vm.formData.fleetNo == undefined
                            ? "请选择车队"
                            : "请选择",
                        disabled:
                          _vm.formData.fleetNo == "" ||
                          _vm.formData.fleetNo == undefined
                            ? true
                            : false
                      },
                      model: {
                        value: _vm.formData.driverName,
                        callback: function($$v) {
                          _vm.$set(_vm.formData, "driverName", $$v)
                        },
                        expression: "formData.driverName"
                      }
                    },
                    _vm._l(_vm.fleetdriverList, function(item) {
                      return _c("el-option", {
                        key: item.ID,
                        attrs: {
                          label: item.driverName,
                          value: item.driverName
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "本次运送总吨数", prop: "carryTotalTon" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入", type: "number" },
                    on: {
                      blur: function($event) {
                        _vm.formData.carryTotalTon = Number(
                          _vm.formData.carryTotalTon
                        )
                      },
                      input: function($event) {
                        return _vm.inputChange($event)
                      }
                    },
                    model: {
                      value: _vm.formData.carryTotalTon,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "carryTotalTon", $$v)
                      },
                      expression: "formData.carryTotalTon"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "运输名称", prop: "transportName" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入", clearable: "" },
                    on: {
                      input: function($event) {
                        return _vm.inputChange($event)
                      }
                    },
                    model: {
                      value: _vm.formData.transportName,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "transportName", $$v)
                      },
                      expression: "formData.transportName"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.dialogVisible = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.dialogClick } },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }